import React, { useState, useEffect } from "react";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import Icon from "../doctor-console/Utils/Icons";
// //For black icons when not clicked
// import { ReactComponent as PatientIcon } from './IconsForTiles/PatientIcon.svg';
// import { ReactComponent as ItemIcon } from './IconsForTiles/AvailableServices.svg';
// import { ReactComponent as ProductIcon } from './IconsForTiles/ProductInventory.svg';
// import { ReactComponent as EstimatesIcon } from './IconsForTiles/CostEstimates.svg';
// import { ReactComponent as InvoiceIcon } from './IconsForTiles/BillingInvoices.svg';
// import { ReactComponent as PaymentIcon } from './IconsForTiles/PaymentDetails.svg';
// //For white icons when clicked
// import { ReactComponent as PatientIconWhite } from './IconsForTiles/PatientIconWhite.svg';
// import { ReactComponent as ItemIconWhite } from './IconsForTiles/AvailableServicesWhite.svg';
// import { ReactComponent as ProductIconWhite } from './IconsForTiles/ProductInventoryWhite.svg';
// import { ReactComponent as EstimatesIconWhite } from './IconsForTiles/CostEstimatesWhite.svg';
// import { ReactComponent as InvoiceIconWhite } from './IconsForTiles/BillingInvoicesWhite.svg';
// import { ReactComponent as PaymentIconWhite } from './IconsForTiles/PaymentDetailsWhite.svg';

// import { ReactComponent as ReportIcon } from './IconsForTiles/ReportAnalysis.svg';

import { useHistory, useLocation } from "react-router-dom";

const SideNavbar = ({ children }) => {
  const history = useHistory();
  const location = useLocation();

  // State to track if the screen is small
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  // State to track the active section
  const [activeSection, setActiveSection] = useState(null);

  useEffect(() => {
    // Function to check screen size
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    // Check initial screen size and add event listener
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  // Navigate to the specific section and set active section
  const handleSectionClick = (section) => {
    const newLocation = `/doctor/${section.toLowerCase()}`;
    console.log("Navigating to:", newLocation);
    setActiveSection(section); // Set the active section
    history.push(newLocation);
  };

  useEffect(() => {
    // Redirect to login if no accessToken
    if (
      sessionStorage.getItem("accessToken") === undefined ||
      sessionStorage.getItem("accessToken") === null
    ) {
      history.push("/login");
    }
  }, [history]);

  const sections = [
    {
      label: "Patient",
      displayLabel: "Patient Records",
      icon: <Icon name="patientDetails" size={26} />,
      iconWhite: <Icon name="patientDetailsWhite" size={26} />,
    },
    {
      label: "Item",
      displayLabel: "Available Services",
      icon: <Icon name="availableServices" size={26} />,
      iconWhite: <Icon name="availableServicesWhite" size={26} />,
    },
    {
      label: "Product",
      displayLabel: "Product Inventory",
      icon: <Icon name="productInventory" size={26} />,
      iconWhite: <Icon name="productInventoryWhite" size={26} />,
    },
    {
      label: "Estimates",
      displayLabel: "Cost Estimates",
      icon: <Icon name="costEstimates" size={26} />,
      iconWhite: <Icon name="costEstimatesWhite" size={26} />,
    },
    {
      label: "Invoice",
      displayLabel: "Billing Invoices",
      icon: <Icon name="billingInvoices" size={26} />,
      iconWhite: <Icon name="billingInvoicesWhite" size={26} />,
    },
    {
      label: "Payment",
      displayLabel: "Payment Details",
      icon: <Icon name="paymentDetails" size={26} />,
      iconWhite: <Icon name="paymentDetailsWhite" size={26} />,
    },
    {
      label: "Report",
      displayLabel: "Reports & Analytics",
      icon: <Icon name="reportAnalysis" size={26} />, // Only black for Reports
      iconWhite: <Icon name="reportAnalysis" size={26} />,
    },
  ];


  return (
    <div className="top-cards-layout">
      <header className="top-cards-header">
        <div className="scroll-container" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>

          {/* {isSmallScreen && (
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '7.5px', marginRight: '7.5px', marginLeft: '7.5px' }}>
            <button
              className="scroll-arrow left"
              id="leftArrow"
              style={{
                position: 'relative',
                top: '0',
                transform: 'none',
                background: '#ffffff',
                color: '#808285',
                border: 'none',
                padding: '10px',
                cursor: 'pointer',
                zIndex: '1',
                borderRadius: '5px',
                fontSize: '18px',
                boxShadow: '0px 4px 4px 0px #0000004D',
                marginRight: '10px',
                opacity: '0.5',
                pointerEvents: 'none'
              }}
              onClick={() => {
                const container = document.querySelector('.cards-row');
                container.scrollLeft -= 750;
                const leftArrow = document.getElementById('leftArrow');
                const rightArrow = document.getElementById('rightArrow');
                if (container.scrollLeft - 750 <= 0) {
                  leftArrow.style.background = '#DCDCDC';
                  leftArrow.style.cursor = 'not-allowed';
                  leftArrow.style.pointerEvents = 'none';
                } else {
                  leftArrow.style.background = '#ffffff';
                  leftArrow.style.cursor = 'pointer';
                  leftArrow.style.pointerEvents = 'auto';
                }
                rightArrow.style.background = '#ffffff';
                rightArrow.style.cursor = 'pointer';
                rightArrow.style.pointerEvents = 'auto';
              }}
            >
              &lt;
            </button>
            <button
              className="scroll-arrow right"
              id="rightArrow"
              style={{
                position: 'relative',
                top: '0',
                transform: 'none',
                background: '#ffffff',
                color: '#808285',
                border: 'none',
                padding: '10px',
                cursor: 'pointer',
                zIndex: '1',
                borderRadius: '5px',
                fontSize: '18px',
                boxShadow: '0px 4px 4px 0px #0000004D',


                // marginRight: '10px'
              }}
              onClick={() => {
                const container = document.querySelector('.cards-row');
                container.scrollLeft += 750;
                const leftArrow = document.getElementById('leftArrow');
                const rightArrow = document.getElementById('rightArrow');
                leftArrow.style.background = '#ffffff';
                leftArrow.style.cursor = 'pointer';
                leftArrow.style.pointerEvents = 'auto';
                if (container.scrollLeft + 750 + container.clientWidth >= container.scrollWidth) {
                  rightArrow.style.background = '#DCDCDC';
                  rightArrow.style.cursor = 'not-allowed';
                  rightArrow.style.pointerEvents = 'none';
                } else {
                  rightArrow.style.background = '#ffffff';
                  rightArrow.style.cursor = 'pointer';
                  rightArrow.style.pointerEvents = 'auto';
                }
              }}
            >
              &gt;
            </button>
            <script>
              {`
      window.addEventListener('load', () => {
        const leftArrow = document.getElementById('leftArrow');
        leftArrow.style.background = '#DCDCDC';

      });
    `}
            </script>
          </div>
          )} */}

          <div className="cards-row" style={{ display: 'flex', overflowX: 'auto', whiteSpace: 'nowrap', padding: '10px 0', scrollBehavior: 'smooth', overflowX: 'scroll', '-webkit-overflow-scrolling': 'touch', scrollbarWidth: 'none', msOverflowStyle: 'none', '&::-webkit-scrollbar': { display: 'none' } }}>
            {sections.map((section, idx) => {
              const isActive = location.pathname.includes(section.label.toLowerCase());
              const isSelected = activeSection === section.label;

              return (
                <div
                  key={idx}
                  className={`top-card ${isActive ? "active" : ""}`}
                  style={{
                    flex: '0 0 auto',
                    minWidth: isSmallScreen ? '20%' : '160px', // Reduced width
                    maxWidth: isSmallScreen ? '20%' : '170px',
                    boxSizing: 'border-box',
                    marginRight: '5px',
                    marginLeft: '12px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    // padding: '12px 8px', // Better inner spacing
                    textAlign: 'center', height:'1%'
                  }}
                  onClick={() => handleSectionClick(section.label)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") handleSectionClick(section.label);
                  }}
                  aria-pressed={isActive}
                >
                  <div className="top-card-icon" style={{ marginBottom: '8px' }}>
                    {isActive && section.iconWhite ? section.icon : section.icon}
                  </div>
                  <div className="top-card-text">
                    <span
                      className="top-card-title"
                      style={{
                        color: isActive ? "black" : "black",
                        // fontSize: isSmallScreen ? '14px' : '12px',
                        // fontWeight: '500',
                        whiteSpace: 'normal',
                        lineHeight: '1',
                        fontSize: isSmallScreen ? '14px' : '14px',
                      }}
                    >
                      {/* {isSmallScreen ? section.label : section.displayLabel} */}
                       {isSmallScreen ? section.displayLabel : section.displayLabel}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </header>

      <main className="top-cards-content">{children}</main>
    </div>
  );
};

export default SideNavbar;
